const MessageArrowIcon = () => {
  return (
    <svg
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 6.625V1H1V12.25H8.5M16 10.375H10.75"
        stroke="#121212"
        stroke-width="1.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.625 8.5L10.75 10.375L12.625 12.25M1 1L8.5 6.625L16 1"
        stroke="#121212"
        stroke-width="1.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export default MessageArrowIcon;
